import styled from 'styled-components/macro'
import { BaseColor, Icon as UCIcon, themeColor, spacing, linkReset, transitions } from '@unbounded/unbounded-components'
import Layout from '~layout'

export const BreadcrumbsContainer = styled(Layout.PreHeader)`
  display: flex;
  align-items: center;
  margin-top: ${spacing(-0.5)};
`

export const Crumb = styled.div`
  display: flex;
  align-items: center;
  color: ${themeColor(BaseColor.shade_50)};

  &:last-child {
    color: ${themeColor(BaseColor.shade_70)};
  }

  & > a {
    ${linkReset};
    ${transitions(['color'])};

    &:hover {
      color: ${themeColor(BaseColor.shade_60)};
    }
  }
`

export const Icon = styled(UCIcon)`
  margin: 0 ${spacing(0.5)};
`

export const Link = styled.span``
